import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Roles = {
	member: "member",
	manager: "manager",
	server: "servertoserver"
};

const Methods = {
	token: "SdkToken",
	oauth: "OAuth2ClientCredentials"
};

const Authorization = ({ roles, methods }) => {
	const header = <div className="heading">Authorization Required</div>;

	// Renders individual roles
	const mapAuthToDisplay = auth => {
		switch (auth.toLowerCase()) {
			case Roles.manager:
				return (
					<span key={Roles.manager} className="role manager">
						Manager
					</span>
				);
			case Roles.member:
				return (
					<span key={Roles.member} className="role member">
						Member
					</span>
				);
			case Roles.server:
				return (
					<span key={Roles.server} className="role server">
						<Link to="/getting-started/server-authentication">
							Server <i className="fa fa-info-circle" />
						</Link>
					</span>
				);
			// no default
		}
	};

	let auth;
	if (!Array.isArray(roles) || roles.length < 1) {
		// No roles defined
		if (
			!Array.isArray(methods) ||
			methods.length !== 1 ||
			methods[0] !== Methods.oauth
		)
			// Any role is valid but not managers specifically
			auth = [Roles.member, Roles.server].map(role => mapAuthToDisplay(role));
		// OAuth-only method means only server-auth allowed
		else auth = [mapAuthToDisplay(Roles.server)];
	} else {
		// Apply logic depending on how many roles were returned
		switch (roles.length) {
			case 1:
				auth = mapAuthToDisplay(roles[0]);
				break;
			case 2:
				// If it's member & manager, member is good enough
				if (roles.some(role => role.toLowerCase() === Roles.member)) {
					auth = [mapAuthToDisplay(Roles.member)];
					break;
				}
				// Otherwise map them properly
				auth = roles.map(role => mapAuthToDisplay(role));
				break;
			default:
				// Return them all
				auth = [Roles.member, Roles.server].map(role => mapAuthToDisplay(role));
				break;
		}
	}

	// Might as well check
	if (auth === undefined) return null;

	return (
		<div className="meta">
			{header}
			{auth}
		</div>
	);
};

Authorization.propTypes = {
	roles: PropTypes.array,
	methods: PropTypes.array
};

export default Authorization;



// WEBPACK FOOTER //
// ./src/components/api/Authorization.js